module.exports = __webpack_public_path__ + "site/img/indexsd1zh.43e9966d.jpg";